import React from "react";
import format from "date-fns/format";
import Grid from "@material-ui/core/Grid";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import InfoPanel from "components/InfoPanel";
import parseISO from "date-fns/parseISO";

interface Props {
  horse: racehorse360.IHorse;
}

const InfoPanelsGrid = (props: Props) => {
  const { horse } = props;
  const gradientOptions = {
    topColor: horse.currentFacility?.backgroundColor || "#bababa",
    bottomColor: horse.currentFacility?.strokeColor
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <InfoPanel
          title={"Dam"}
          value={horse?.damName}
          gradientOptions={gradientOptions}
        />
      </Grid>
      <Grid item xs={6}>
        <InfoPanel
          title={"Date of Birth"}
          value={
            horse?.birthday && format(parseISO(horse?.birthday), "MMMM d, yyyy")
          }
          gradientOptions={gradientOptions}
        />
      </Grid>
      <Grid item xs={6}>
        <InfoPanel
          title={"Sire"}
          value={horse?.sireName}
          gradientOptions={gradientOptions}
        />
      </Grid>
      <Grid item xs={6}>
        <InfoPanel
          title={"Registration Number"}
          value={horse?.registrationNumber}
          gradientOptions={gradientOptions}
        />
      </Grid>
    </Grid>
  );
};

export default React.memo(InfoPanelsGrid);
